import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';

import Section from 'components/common/Section';

import authApi from 'api/modules/authApi';
import paths from 'routes/paths';

const PasswordResetConfirm = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const uid = searchParams.get('uid');
  const token = searchParams.get('token');

  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    password: '',
    confirmPassword: '',
  });

  const handleFieldChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async e => {
    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }

    if (formData.password.length < 8) {
      toast.error('Password must be at least 8 digits');
      return;
    }

    setIsLoading(true);

    try {
      await authApi.passwordResetConfirm({
        uid,
        token,
        new_password: formData.password,
      });

      toast.success('Password reset successfully');
      navigate(paths.login);
    } catch (error) {
      toast.error('Failed to reset password');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Section className="py-0">
      <Row className="flex-center min-vh-100 py-6">
        <Col sm={10} md={8} lg={6} xl={5} className="col-xxl-4">
          <Card>
            <Card.Body className="p-4 p-sm-5">
              <div className="text-center">
                <h5>Reset new password</h5>

                <Form className="mt-3" onSubmit={handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Control
                      placeholder="New Password"
                      value={formData.password}
                      name="password"
                      onChange={handleFieldChange}
                      type="password"
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Control
                      placeholder="Confirm Password"
                      value={formData.confirmPassword}
                      name="confirmPassword"
                      onChange={handleFieldChange}
                      type="password"
                    />
                  </Form.Group>

                  <Button
                    type="submit"
                    className="w-100"
                    disabled={
                      !formData.password ||
                      !formData.confirmPassword ||
                      isLoading
                    }
                  >
                    Set password
                  </Button>
                </Form>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Section>
  );
};

export default PasswordResetConfirm;
